import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import swe from './swe.json';

// The URL determines the language, so visitors and crawlers see the same content.
const language = typeof window !== 'undefined' && /^\/en(?:\/|$)/.test(window.location.pathname) ? 'en' : 'swe';
i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  initImmediate: false,
  lng: language,
  fallbackLng: 'swe',
  resources: { en, swe },
  interpolation: { escapeValue: false },
});
export default i18n;